var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project && _vm.project.depLoaded)?_c('render',{ref:"render",attrs:{"project":_vm.project,"currentPage":_vm.currentPage}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }